__turbopack_context__.v({
  "FeaturedProducts": "FeaturedProducts-module__M7_IQq__FeaturedProducts",
  "products": "FeaturedProducts-module__M7_IQq__products",
});
